import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Input } from '@components/ui';

const MILESTONE_ICONS = [
  { value: '🎯', label: 'Meta' },
  { value: '🚀', label: 'Lanzamiento' },
  { value: '🏁', label: 'Fin' },
  { value: '📅', label: 'Fecha' },
  { value: '⭐', label: 'Importante' },
  { value: '🔔', label: 'Recordatorio' },
  { value: '📊', label: 'Revisión' },
  { value: '🎉', label: 'Celebración' },
  { value: '💡', label: 'Idea' },
  { value: '🔒', label: 'Bloqueo' },
  { value: '✅', label: 'Completado' },
  { value: '📦', label: 'Entrega' },
];

export default function MilestoneModal({
  isOpen,
  onClose,
  onSubmit,
  projectId,
  editData = null,
  isLoading = false,
}) {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    date: '',
    icon: '🎯',
  });

  useEffect(() => {
    if (isOpen) {
      if (editData) {
        setFormData({
          name: editData.name || '',
          description: editData.description || '',
          date: editData.date ? new Date(editData.date).toISOString().split('T')[0] : '',
          icon: editData.icon || '🎯',
        });
      } else {
        setFormData({
          name: '',
          description: '',
          date: '',
          icon: '🎯',
        });
      }
    }
  }, [isOpen, editData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.date) return;

    onSubmit({
      ...formData,
      projectId,
    });
  };

  const labelStyle = {
    display: 'block',
    fontSize: '14px',
    fontWeight: '500',
    color: '#475569',
    marginBottom: '6px',
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={editData ? 'Editar Hito' : 'Nuevo Hito'}
      size="md"
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            loading={isLoading}
            disabled={!formData.name || !formData.date}
          >
            {editData ? 'Actualizar' : 'Crear Hito'}
          </Button>
        </>
      }
    >
      <form onSubmit={handleSubmit}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <Input
            label="Nombre del Hito"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Ej: Lanzamiento Beta, Demo Cliente..."
            required
          />

          <Input
            label="Fecha"
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            required
          />

          <div>
            <label style={labelStyle}>Descripción (opcional)</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Describe el hito..."
              rows={3}
              style={{
                width: '100%',
                padding: '10px 16px',
                backgroundColor: '#f8fafc',
                border: '1px solid #e2e8f0',
                borderRadius: '12px',
                fontSize: '14px',
                color: '#1e293b',
                resize: 'vertical',
                outline: 'none',
              }}
            />
          </div>

          <div>
            <label style={labelStyle}>Icono</label>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(6, 1fr)',
                gap: '8px',
              }}
            >
              {MILESTONE_ICONS.map((iconOption) => (
                <button
                  key={iconOption.value}
                  type="button"
                  onClick={() => setFormData((prev) => ({ ...prev, icon: iconOption.value }))}
                  title={iconOption.label}
                  style={{
                    width: '44px',
                    height: '44px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '20px',
                    borderRadius: '10px',
                    border:
                      formData.icon === iconOption.value
                        ? '2px solid #667eea'
                        : '1px solid #e2e8f0',
                    backgroundColor:
                      formData.icon === iconOption.value ? '#667eea10' : '#f8fafc',
                    cursor: 'pointer',
                    transition: 'all 0.15s',
                  }}
                >
                  {iconOption.value}
                </button>
              ))}
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
}

MilestoneModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  projectId: PropTypes.number,
  editData: PropTypes.object,
  isLoading: PropTypes.bool,
};
